/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
export const OPACITY_ACTIVE = 0.4;
export const OPACITY_INACTIVE = 0;
export const SEGMENT_ELEMENT_SIZE = 0.15;
export const BOUNDINGBOX_EDITOR_TYPE_NAME = 'EditorBoundingBox';
export const DEFAULT_BOUNDINGBOX_EDITOR_NAME = 'boundingBoxEditor';
export const DEFAULT_CAMERA_NAME = 'default';
//# sourceMappingURL=constants.js.map